import { CertificateV2 } from '@sdir/httpclient/lib/clients/aps/personalcertificate';
import { useContext } from 'react';
import { Loadable } from '../../types';
import { CertificateCodesContext } from '../contexts/CertificateCodesContext';

export const useCertificateCodes = (): Loadable<CertificateV2[]> => {
  const context = useContext(CertificateCodesContext);

  return context;
};
